import faker from 'faker'
import gravyAxios from "@/plugins/axios";

const templatesStore = {
    state: () => ({
        templates: [],
        template: null,
        previewTemplate: null
    }),
    actions: {
        getTemplates: async ({commit}, clientId) => {
            let templates = await gravyAxios.get(`/templates/${clientId}`)
            if (templates.data) {
                commit('SET_TEMPLATES', templates.data)
            }
        },
        createTemplate: async ({commit}, newTemp) => {
            let newTemplate = await gravyAxios.post('/template', newTemp)
            commit('NEW_TEMPLATE', newTemplate.data)
        },
        deleteTemplate: async ({commit}, tempToDelete) => {
            let deletedTemplate = await gravyAxios.delete('/template/' +tempToDelete.id,)
            commit('DELETE_TEMPLATE', tempToDelete.id)
        },
        previewTemplate: async ({commit}, previewTemplate) => {
            let response = await gravyAxios.post('/template/try', previewTemplate)
            commit('setPreviewTemplate', response.data)
        },
        updateTemplate: async ({commit}, templateToUpdate) => {

            let updatedTemplate = await gravyAxios.patch('/template', templateToUpdate)
            commit('UPDATE_TEMPLATE', updatedTemplate.data)
        },
        getTemplate: async ({commit}, templateId) => {
            let template = await gravyAxios.get('template/' + templateId)
            commit('SET_TEMPLATE', template.data)
        },
        resetTemplates: ({commit}) => {
            commit('RESET_TEMPLATES')
        },
    },
    mutations: {
        NEW_TEMPLATE: (state, template) => {
            state.templates = [...state.templates, template];
        },

        UPDATE_TEMPLATE: (state, updatedTemplate) => {
            const index = state.templates.findIndex(template => template.id === updatedTemplate.id);
            if (index !== -1) {
                state.templates.splice(index, 1, updatedTemplate);
            }
        },

        SET_TEMPLATES: (state, templates) => {
            if (!templates) return
            state.templates = templates
        },
        setPreviewTemplate: async (state, template) => {
            state.previewTemplate = template
        },
        SET_TEMPLATE: (state, template) => {
            state.template = template

            if (template.emailTemplateVersion) {
                state.template.subject = template.emailTemplateVersion.subject
                state.template.body = template.emailTemplateVersion.body
            } else {
                state.template.subject = ''
                state.template.body = ''
            }

        },
        DELETE_TEMPLATE: (state, templateId) => {
            const index = state.templates.findIndex(template => template.id === templateId);
            state.templates.splice(index, 1);
        },
        RESET_TEMPLATES: state => {
            state.templates = []
        }

    },
    getters: {
        getTemplates: state => {
            return state.templates
        },
        getTemplate: state => {
            return state.template
        },
        getPreviewTemplate: state => {
            return state.previewTemplate
        }
    }
}
export default templatesStore
const generateTemplates = async () => {
    let templatesArray = []
    for (let i = 0; i < 50; i++) {
        let templateName = await faker.random.words()

        const template = {
            id: i+1,
            name: templateName,
            content: 'This is a template for {{Client Name}} for the product {{Product Name}}. ' +
                'This is our {{Outerach #}} time reaching out. First Name: {{First Name}}. Last Name: {{Last Name}}. ' +
                'Invoice Link: {{Invoice Link}}',
            to: '',
            from: '',
            clientId: Math.floor(Math.random() * 10),
        }
        templatesArray.push(template)
    }
    return templatesArray
}
